import React, { useState } from 'react';
import { Row, Col} from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { useGetPartysByBookId } from "../../../../hooks/services/sBook/useOfParty"
import { useGetSectionsByBookId2 } from "../../../../hooks/services/sBook/useOfSection"

import Picker from '../../../Common/Picker';
import CValidator from '../../../Common/CValidator';
import { OverflowSet } from '@fluentui/react/lib/OverflowSet';
import Message from '../../../Common/Message';
import List from '../../../Templates/List';
import ListPagination from '../../../Templates/List/ListPagination';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../common/CommonFuctions';
import { _global_buttonStyles } from '../../../../common/ObjectStructures/Trasnversal';

const SidePanelPartySections = (props) => {
    const { t } = useTranslation();
  
    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;
   
    const inputParam_SetterSelectedPartySectionItemList = props.setterSelectedPartySectionItemList;

    const inputParam_BookId = props.bookId;

    const inputParam_ForceUpdate = props.forceUpdate !== null && props.forceUpdate !== undefined ? props.forceUpdate : false;
    const inputParam_SetterForceUpdate = props.setterForceUpdate !== null && props.setterForceUpdate !== undefined ? props.setterForceUpdate : null;
       
    
    const buttonAddStyles = { root: { float: "right" } };

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);


    const [isInvalidParty, setIsInvalidParty] = useState(false);
    const [isInvalidSection, setIsInvalidSection] = useState(false);
    const [isInvalidList, setIsInvalidList] = useState(false);

    const [selectedPartyItemList, setSelectedPartyItemList] = useState(null);
    const [selectedSectionItem, setSelectedSectionItem] = useState(null);


    const [partySectionList, setPartySectionList] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 1000, filters: []});

    const [partyList, setPartyList] = useState(null);
    useGetPartysByBookId(inputParam_BookId, partyList, setPartyList, null, true, inputParam_IsPanelOpen);

    const [sectionList, setSectionList] = useState(null);
    useGetSectionsByBookId2(inputParam_BookId, sectionList, setSectionList, null, true, false, [], inputParam_IsPanelOpen, null, inputParam_ForceUpdate, inputParam_SetterForceUpdate);

    const [itemToDelete, setItemToDelete] = useState(null);

    const validateForm = () => {
        const validParty = selectedPartyItemList !== null && selectedPartyItemList.length > 0;
        const validSection = selectedSectionItem !== null;

        setIsInvalidParty(!validParty)
        setIsInvalidSection(!validSection)

        return validParty && validSection;
    };
  
    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };
    const onDeleteSectionPartyFromListClick = (item, setItemToDelete) => {
        setItemToDelete(item);
    };
    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        setShowMessage(false);
        setIsInvalidParty(false)
        setIsInvalidSection(false)
        setIsInvalidList(false)
        
        setPartySectionList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: null
        }));
        setSelectedPartyItemList(null)
        setSelectedSectionItem(null)

        sectionList.map(x => x.checked = false)
        setSectionList(sectionList);
    };

    const onAddPartySectionToList = () => {
        const _isValidForm = validateForm();

        if (_isValidForm) {
            //Enviar a guardar.
            selectedPartyItemList.forEach(element => {
                if (partySectionList.data === null) {
                    partySectionList.data = [];
                }

                const _lowerId = partySectionList.data.length !== 0 ? partySectionList.data.reduce((min, obj) => obj.id < min ? obj.id : min, partySectionList.data[0].id) : 0;  

                partySectionList.data.push({
                    id: (_lowerId > 0 ? 0 : _lowerId) -1,
                    bookId: inputParam_BookId,
                    sectionId: selectedSectionItem.id,
                    sectionName: selectedSectionItem.name,
                    partyId: element.id,
                    partyName: element.name,
                })
            });

            let result = partySectionList.data.filter((e, i) => {
                return partySectionList.data.findIndex((x) => {
                return x.sectionId === e.sectionId && x.partyId === e.partyId;}) === i;        
            });

            setPartySectionList(prevState => ({
                ...prevState,
                fireUpdate: true,
                data: result
            }));
            
            partyList.map(x => x.checked = false)
            setPartyList(partyList);

            sectionList.map(x => x.checked = false)
            setSectionList(sectionList);  

            setSelectedPartyItemList(null)
            setSelectedSectionItem(null)
            
            setShowMessage(false);
            setIsInvalidList(false);
            setIsInvalidParty(false);
            setIsInvalidSection(false);
        }
        else {
            setMessage(t('data-lang-msg-requireddatanotset'))
            setMessageType("warning")
            setShowMessage(true);
        }
    };

    const onAddPartySectionToBox = () => {
        const _isValidForm = partySectionList.data !== null && partySectionList.data.length > 0;

        if (_isValidForm) {
            //Enviar a guardar.
            inputParam_SetterSelectedPartySectionItemList(partySectionList.data);
            onDismissPanel();            
        }
        else {
            setMessage(t('data-lang-msg-requireddatanotset'))
            setMessageType("warning")
            setShowMessage(true);
        }

        setIsInvalidList(!_isValidForm)
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
        setSelectedPartyItemList(null);
        setSelectedSectionItem(null);
    };
    
    const onClosePanel = () => {
        setPartyList(null);
        onDismissPanel();
    };

    const onChangeParty = (currentNode, selectedNodes) => {
        setSelectedPartyItemList(selectedNodes)
           
        let items = [...partyList];

        items.forEach(x => {
            x.checked = false;
            selectedNodes.forEach(y => {
                if (x.id === y.id) {
                    x.checked = y.checked;
                }
            })
        })

        setIsInvalidParty(false)
        setPartyList(items);   
        setShowMessage(false);
    };

    const onChangeSection = (currentNode, selectedNodes) => {
        setSelectedSectionItem(currentNode)
  
        let items = [...sectionList];

        items.forEach(x => {
            x.checked = false;
            if (x.id === currentNode.id) {
                x.checked = currentNode.checked;
            }
        })

        setIsInvalidSection(false)
        setSectionList(items); 
        setShowMessage(false);
    };

    const onRenderFooterContent = () => {
        return <div>
            <PrimaryButton onClick={ onAddPartySectionToBox } styles={ _global_buttonStyles }>{ t('data-lang-btn-acept') }</PrimaryButton>
            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
        </div>
    }

    if (itemToDelete !== null) {
        let newList = [];

        partySectionList.data.forEach(obj => {
            if (!(obj.partyId === itemToDelete.partyId && obj.sectionId === itemToDelete.sectionId)) {
                newList.push(obj)
            }
        })

        setPartySectionList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: newList
        }));

        setItemToDelete(null);
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-lbl-addpartysection') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-3">
                    <Col>
                        <Picker
                            data={ sectionList !== null ? sectionList : [] }
                            mode="simpleSelect"
                            className="dropdown-checkbox"
                            isInValid={ isInvalidSection }
                            texts={{ placeholder: t('data-lang-lbl-choose') }}
                            onChange={ onChangeSection }
                            labelText={ t('data-lang-lbl-candidatesections') }
                            refresh={true}
                        />
                        <CValidator isInValid={ isInvalidSection } />
                    </Col>
                </Row>
                <Row className="pt-3">
                    <Col>
                        <Picker
                            data={ partyList !== null ? partyList : [] }
                            mode="multiSelect"
                            className="dropdown-checkbox remove-position"
                            isInValid={ isInvalidParty }
                            texts={{ placeholder: t('data-lang-lbl-choose') }}
                            onChange={ onChangeParty }
                            labelText={ t('data-lang-lbl-candidatepartys') }
                            refresh={true}
                        />
                        <CValidator isInValid={ isInvalidParty } />
                    </Col>
                </Row>
                <Row className="pt-3">
                    <Col>
                        <PrimaryButton onClick={ onAddPartySectionToList } styles={buttonAddStyles}>{t('data-lang-btn-add')}</PrimaryButton>
                    </Col>
                </Row>
                <Row className="pt-3">
                    <Col>
                        <List
                            topValue="87.5%"
                            listLocalStoragePageSizeVariableName="sectionPartysToAdd"
                            className="no-compact-list big-header"
                            manipulateLocalData={ true }
                            setData={setPartySectionList}
                            data={partySectionList}
                            columns={[
                                {
                                    key: 'all-props-code',
                                    name: t('data-lang-lbl-partysection'),
                                    fieldName: 'all-props-code',
                                    minWidth: 400,
                                    maxWidth: 400,
                                    onRender:(item) => {
                                        return <div>
                                            <div><b>{t('data-lang-lbl-sectionname') }</b>&nbsp;:&nbsp;{ item.sectionName }</div>
                                            <div><b>{t('data-lang-lbl-partyname') }</b>&nbsp;:&nbsp;{ item.partyName }</div>
                                        </div>
                                    }
                                },
                                {  
                                    key: 'id',
                                    name: t('data-lang-lbl-actions'),
                                    fieldName: 'id',
                                    //minWidth: "10%",
                                    //maxWidth: "10%",
                                    onRender:(item, row) => {
                                        return <div>
                                                <OverflowSet
                                                    className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                                                    role="menubar"
                                                    items={[
                                                        {
                                                            key: 'item1',
                                                            icon: 'Delete',
                                                            name: t('data-lang-btn-delete'),
                                                            title: t('data-lang-btn-delete'),
                                                            onClick: () => onDeleteSectionPartyFromListClick(item, setItemToDelete),
                                                        }
                                                    ]}
                                                    onRenderOverflowButton={__onRenderOverflowButton}
                                                    onRenderItem={__onRenderOverflowItem}
                                                />
                                        </div>
                                    }
                                }
                            ]}
                        />
                        <CValidator isInValid={isInvalidList} />
                    </Col>
                </Row>
                <Row>
                    <Col className="message-verybottom-panel-medium-pagination">
                        <ListPagination
                            listLocalStoragePageSizeVariableName="sectionPartysToAdd"
                            data={ partySectionList }
                            setData={ setPartySectionList } />
                    </Col>
                </Row>
                <Row>
                <Col className="message-verybottom-panel-medium-message">
                        <Message message={ message } display={ showMessage === null? false : showMessage } messageType={messageType} setterShowMessage={ setShowMessage } />
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

export default SidePanelPartySections;